import { Product, Venue } from "@/graphql/operations";
import { ApolloError } from "@apollo/client";
import { createContext } from "react";

type VenueContext = {
  defaultVenue: Venue | undefined;
  error: ApolloError | undefined;
  hasMultipleVenues: boolean;
  hasSingleVenue: boolean;
  loading: boolean;
  productMap: Map<string, Product & { venues: Venue[]; defaultVenue?: Venue }>;
  venueMap: Map<string, Venue>;
  venues: Venue[];
};

export const VenueContext = createContext<VenueContext | null>(null);
